import { useEffect } from "react";
import { setMutationErrorReporter } from "../lib/query";
import { useToast } from "../ui/Toast";

/** Routes failed mutations without their own error handling to the toast stack (lib/query.ts). */
export function MutationErrorToasts() {
  const toast = useToast();
  useEffect(() => setMutationErrorReporter((message) => toast.error(message)), [toast]);
  return null;
}
